import React from "react";

const FacebookSVG = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.04623 6.365V9.113H7.03223V12.473H9.04623V22.459H13.1802V12.474H15.9552C15.9552 12.474 16.2152 10.863 16.3412 9.101H13.1972V6.803C13.1972 6.46 13.6472 5.998 14.0932 5.998H16.3472V2.5H13.2832C8.94323 2.5 9.04623 5.863 9.04623 6.365Z"
        fill="#0F172A"
      />
    </svg>
  );
};

export default FacebookSVG;
